import Storage from './Storage';

/**
 * Store CountryList
 * 
 */
class CountryList extends Storage {
    storeName = 'country_list_';
    hasOldKey = true;

    /**
     * CountryList constructor
     * 
     * @param {string} id client id
     */
    constructor(id) {
        super();
        this.id = id;
        this.setKey();
    }

    /**
     *  @override
     * 
     * Format data for store
     * 
     * @param {any} data data to store
     * @returns 
     */
     formatSetDataOld(data) {
        let returnData = JSON.stringify({
            'data': (data.data.data) ? data.data.data : null,
            'success' : data.data.success
        });
        return returnData;
    }

}

export default CountryList;